export function dropdownFetchListInProgress(id) {
  return { type: 'FETCH_DROPDOWN_LIST_INPROGRESS', payload: { id } };
}


export function dropdownFetchListDone(id, searchTerm, list) {
  return { type: 'FETCH_DROPDOWN_LIST_DONE', payload: { id, searchTerm, list } };
}


export function dropdownFetchError(id, error) {
  return { type: 'FETCH_DROPDOWN_LIST_ERROR', payload: { id, error } };
}


export function dropdownFetchMount(key, id, type, fields, preload, searchParams) {
  return { type: 'FETCH_DROPDOWN_MOUNT', payload: { key, id, type, fields, preload, searchParams } };
}


export function dropdownFetchMountAll() {
  return { type: 'FETCH_DROPDOWN_MOUNT_ALL' };
}